import { render, staticRenderFns } from "./LoyaltyTerminalesPuntosColombia.vue?vue&type=template&id=32df5069"
import script from "./LoyaltyTerminalesPuntosColombia.vue?vue&type=script&lang=js"
export * from "./LoyaltyTerminalesPuntosColombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports